module.exports = __webpack_public_path__ + "static/media/no-files.f9c84e6f.svg";